var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"prog-main"},[_c('p',{staticClass:"title"},[_vm._v("容量使用:")]),_c('Progress',{attrs:{"percent":_vm.capacityPercent,"stroke-color":['#10DA37', '#F92612']}}),_c('p',[_vm._v(_vm._s(_vm.turnSize(_vm.userInfo.user_size))+" / "+_vm._s(_vm.turnSize(_vm.userInfo.capacity)))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }